const MENU_CLOSE_MS = 400;

export function initSiteHeaderMenu() {
  const menu = document.querySelector(".js-siteMenu");
  const header = document.querySelector(".js-siteHeader");
  const openButtons = document.querySelectorAll(".js-menuOpen");
  const panel = menu?.querySelector(".siteMenu__panel");

  if (!menu || !panel || openButtons.length === 0) return;

  let closeTimer = null;
  let onCloseEnd = null;

  const prefersReducedMotion = () =>
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const syncUi = (open) => {
    menu.setAttribute("aria-hidden", open ? "false" : "true");
    document.body.classList.toggle("is-menuOpen", open);
    header?.classList.toggle("siteHeader--menuOpen", open);

    openButtons.forEach((btn) => {
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      const labelOpen = btn.dataset.labelOpen || "メニューを開く";
      const labelClose = btn.dataset.labelClose || "メニューを閉じる";
      btn.setAttribute("aria-label", open ? labelClose : labelOpen);
    });
  };

  const clearClose = () => {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }

    if (onCloseEnd) {
      panel.removeEventListener("transitionend", onCloseEnd);
      onCloseEnd = null;
    }
  };

  const finishClose = () => {
    clearClose();
    menu.classList.remove("is-closing");
    syncUi(false);
  };

  const setOpen = (open) => {
    if (open) {
      clearClose();
      menu.classList.remove("is-closing");
      menu.classList.add("is-open");
      syncUi(true);
      return;
    }

    if (!menu.classList.contains("is-open")) return;

    menu.classList.remove("is-open");
    menu.classList.add("is-closing");

    openButtons.forEach((btn) => {
      btn.setAttribute("aria-expanded", "false");
      const labelOpen = btn.dataset.labelOpen || "メニューを開く";
      btn.setAttribute("aria-label", labelOpen);
    });

    if (prefersReducedMotion()) {
      finishClose();
      return;
    }

    onCloseEnd = (event) => {
      if (event.target !== panel) return;
      finishClose();
    };

    panel.addEventListener("transitionend", onCloseEnd);
    closeTimer = setTimeout(finishClose, MENU_CLOSE_MS + 50);
  };

  openButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      setOpen(!menu.classList.contains("is-open"));
    });
  });

  menu.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => setOpen(false));
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") setOpen(false);
  });

  initMenuAccordion(menu);
}

function initMenuAccordion(menu) {
  const toggles = menu.querySelectorAll(".js-menuToggle");
  if (toggles.length === 0) return;

  const mq = window.matchMedia("(max-width: 768px)");

  const updateToggleLabel = (btn, open) => {
    const hidden = btn.querySelector(".u-visuallyHidden");
    if (!hidden) return;
    const section = hidden.textContent.split("のサブメニューを")[0];
    hidden.textContent = `${section}のサブメニューを${open ? "閉じる" : "開く"}`;
  };

  toggles.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (!mq.matches) return;

      const item = btn.closest(".siteMenu__item");
      if (!item) return;

      const open = !item.classList.contains("is-open");
      item.classList.toggle("is-open", open);
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      updateToggleLabel(btn, open);
    });
  });
}
